import isNumeric from "./isNumeric";

/**
 * Attempts to coerce the given value if it's numeric (floats and integers).
 * Returns the coerced value as a numeric type when possible. Otherwise, returns
 * the value that was given.
 * @param {*} n
 */
const coerceToFloat = (n) => {
  if (isNumeric(n)) {
    return n;
  }

  const floatRegex = /^-?\d+\.?\d*$/;

  if (typeof n === 'string' && floatRegex.test(n)) {
    return parseFloat(n);
  }

  return n;
};

export default coerceToFloat;
